<template>
  <div  class="container-fluid">
               
            <div class="modal modal-mask" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style="display: block">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                
                <div style="background-color:#FFFF66" class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">                                        
                    <slot name="header"></slot>                       
                </h5>                 
                </div>

                <div v-if="spinner" class="mt-4 mb-4">
                    <div class="d-flex justify-content-center">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>                        
                    </div>
                </div>

                <div v-else>
                <div  style="color:brown" class="modal-body">
                    <slot name="body"></slot>                       
                </div>

                <div class="modal-footer">
                                      
                    <button @click="$emit('hide')" type="button" class="btn btn-secondary" data-dismiss="modal">                    
                        ANNULLA
                    </button>
                    <button :disabled="spinner" @click="processModal()"  type="button" class="btn btn-primary">
                        <i class="far fa-check-circle mr-2" aria-hidden="true"></i>
                        ESEGUI
                        <span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
                    </button>

                </div>
                
            </div>

              </div>
            </div>
          </div>
          
        

  </div>
</template>

<script>

  export default {
     props : ['spinner'],
     components: {},
   
    data () {
      return {
                
        
      }
    },
   
    created () 
    { 
           
      
    },
    methods: 
    {
        
      processModal()
      {
        this.$emit('process')
      }

    
    }
  }
</script>

<style scoped>
  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
</style>
